import React, { Fragment, Component } from 'react'
import { Row, Col, Typography, Modal } from 'antd'
import './index.css'

class TruckLoading extends Component {
  constructor() {
    super()
    this.state = {}
    this.sectionRef0 = React.createRef(),
    this.sectionRef1 = React.createRef(),
    this.sectionRef2 = React.createRef(),
    this.sectionRef3 = React.createRef(),
    this.sectionRef4 = React.createRef(),
    this.sectionRef5 = React.createRef()
    this.sectionRef6 = React.createRef()

  }

  scrollToSection = (index) => {
    if (this[`sectionRef${index}`].current) {
      this[`sectionRef${index}`].current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }

  render() {
    //trim_plan: {
    //   "plan": "plan1",
    //   "rowsUsed": 1,
    //   "emptySpace": 28,
    //   "trucks": [
    //     {
    //       "capacity": 5,
    //       "remaining": 3,
    //       "ulds": [
    //         "PMC"
    //       ]
    //     },
    //     {
    //       "capacity": 5,
    //       "remaining": 5,
    //       "ulds": []
    //     },
    //     {
    //       "capacity": 5,
    //       "remaining": 5,
    //       "ulds": []
    //     },
    //     {
    //       "capacity": 5,
    //       "remaining": 5,
    //       "ulds": []
    //     },
    //     {
    //       "capacity": 5,
    //       "remaining": 5,
    //       "ulds": []
    //     },
    //     {
    //       "capacity": 5,
    //       "remaining": 5,
    //       "ulds": []
    //     }
    //   ]
    // }

    const modalTitle =
          <Row gutter={[{
            xs: 0,
            sm: 0,
            md: 24,
            lg: 48
          }, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 48
          },]} className='modal-title fv-middle'>
            <Col flex={1} className='content-ht-half'>
              <div className=''>
                <h2 className=''>Truck Loading Planner</h2>
              </div>
            </Col>
            <Col>
            </Col>
            <Col flex='none'className='content-ht-half'> 
              <div className='truck-load-details'>
                <Typography.Text className='truck-load-details-title'>Truck Trim Load Flight</Typography.Text> :
                <Typography.Text className='truck-load-details-label'>{this.props.editRecord?.flight_no}</Typography.Text>
              </div>
              <div className='truck-load-details'>
                <Typography.Text className='truck-load-details-title'>Date</Typography.Text> :
                <Typography.Text className='truck-load-details-label'>{this.props.editRecord?.flight_date}</Typography.Text>
              </div>
              <div className='truck-load-details'>
                <Typography.Text className='truck-load-details-title'>Truck Req</Typography.Text> :
                <Typography.Text className='truck-load-details-label'>{this.props.editRecord?.trim_plan?.trucks?.filter(t => t.capacity == 6).length} 6-bin, {this.props.editRecord?.trim_plan?.trucks?.filter(t => t.capacity == 5).length} 5-bin</Typography.Text>
              </div>
            </Col>
          </Row>

    const trucks = (t, i) => {
      return <Fragment key={i} >
        <Col xs={24} className='truck-row' ref={this[`sectionRef${i + 1}`]}>
          <Typography.Title level={5} className='truck-count-title'>
            Truck {i + 1}
          </Typography.Title>
          <Row justify='center' align='middle' gutter={[16, 16]}>
            <Col xs={21}>
              <div className='truck-wrapper'>
                <div className='truck-loading-info'>
                  <Row gutter={[8, 8]} wrap={false} className='truck-container'>
                    <Col flex={'none'} className='truck-door'>
                      <Typography.Title level={5} className='mb-0 truck-door-text'>
                      Door
                      </Typography.Title>
                    </Col>
                    {[...Array(6)].map((_, idx) => (
                      <Col flex={1} key={idx}>
                        <div className='truck-uld-box'>
                          <h2 className='truck-uld-label'>{idx === 0 ? 'F' : idx === 1 ? 'E' : idx === 2 ? 'D' : idx === 3 ? 'C' : idx === 4 ? 'B' : 'A'}</h2>
                          {t.ulds?.[idx]? <p className='uld-container'>{t.ulds?.[idx]?.type + (t.ulds?.[idx]?.uld_no ? t.ulds?.[idx]?.uld_no  : '')}</p> : <p className='empty-container'></p>}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </Col>

            <Col xs={3}>
              <div className='truck-load-details'>
                <Typography.Text className='truck-details-title'>Capacity</Typography.Text> :
                <Typography.Text strong>{t.capacity}</Typography.Text>
              </div>
              <div className='truck-load-details'>
                <Typography.Text className='truck-details-title'>Reg #</Typography.Text> :
                <Typography.Text strong></Typography.Text>
              </div>
            </Col>
          </Row>
        </Col>
      </Fragment>
    }

    return (
      <Modal
        zIndex={9999}
        open={this.props.truckplanner}
        onCancel={() => this.props.openTruckPlanner(false)}
        footer={null}
        width={'80vw'}
        title={modalTitle}
        className='custom-modal truck-loading-modal'
      >
        <div className='truck-loading-page'>
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <Row className='truck-main-wrapper' gutter={[48, 48]}>
                {this.props.editRecord?.trim_plan?.trucks?.map((t, i) => trucks(t, i))}
              </Row>
            </Col>
          </Row>
        </div>
      </Modal>
    )
  }
}

export default TruckLoading
